// /client/src/context/AuthContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('authToken'));
  const navigate = useNavigate();

  useEffect(() => {
    // If a token exists, you might want to fetch user data
    // For now, we'll just assume the token is valid.
    // In a full-scale app, you'd verify the token with the backend here.
    if (token) {
      // For simplicity, we decode the user from the token later
      // or just set a placeholder.
      setUser({ token });
    }
  }, [token]);

  const login = (userData) => {
    localStorage.setItem('authToken', userData.token);
    setToken(userData.token);
    setUser(userData);
    navigate('/dashboard'); // Navigate to dashboard on successful login
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    setToken(null);
    setUser(null);
    navigate('/admin/login');
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the auth context
export const useAuth = () => {
  return useContext(AuthContext);
};